<div class="tw-flex tw-justify-end tw-mr-[5px]">
  <button mat-icon-button (click)="dialogRef.close()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
@if (data.multiple) {
  <h4 id="title" class="tw-text-center tw-mb-2.5 md:!tw-mb-10">
    Select {{ data.kind }}
  </h4>
} @else {
  <h4 id="title" class="tw-text-center tw-mb-2.5 md:!tw-mb-10">
    Select Default {{ data.kind }}
  </h4>
}
<mat-tab-group class="borderless -small-labels">
  <mat-tab label="All {{ data.kind }}s">
    <div class="tw-mt-6">
      <div class="tw-px-2.5 md:tw-px-6">
        @if (getScrollingList()) {
          <search-filter
            [filterConfig]="filterConfig"
            [search]="_itemSelectorService.search"
            [doSearch]="getScrollingList().doSearch"
            class="tw-block tw-w-full tw-min-w-0 tw-mb-4"
          />
        }
        @if (foldersSupported) {
          <folder-path
            [folderTree]="selectFolderDialogService.folderTree()"
            [folderId]="selectFolderDialogService.currentParentFolderId"
            (folderClicked)="enterFolder({ id: $event })"
            [rootName]="data.kind + 's'"
          />
        }
        <rv-divider class="tw-mb-4"></rv-divider>
        <table class="tw-w-full">
          <thead>
            <tr class="list-header">
              <th>Name</th>
            </tr>
          </thead>
        </table>
      </div>
      <mat-dialog-content>
        @if (getScrollingList()) {
          <cdk-virtual-scroll-viewport
            itemSize="54"
            class="item-selector-viewport tw-h-dvh md:!tw-max-h-[calc(100vh-500px)] md:!tw-min-h-[30vh] tw-w-full tw-overflow-x-hidden tw-overflow-y-auto"
            #scrollViewport
          >
            <table
              class="tw-table-fixed tw-w-full"
              rvSpinner="items-list-loader"
              [rvShowSpinner]="
                selectFolderDialogService.loading() ||
                getScrollingList().loadingItems
              "
            >
              <tbody>
                <ng-container *cdkVirtualFor="let item of items">
                  @let itemId = getItemId(item);

                  @if (item.isFolder) {
                    <tr (click)="enterFolder(item)">
                      <td class="folder">
                        <div class="tw-flex tw-items-center tw-gap-2.5">
                          <mat-icon
                            class="tw-text-gray-500 tw-ml-[7px]"
                            svgIcon="folder"
                          />
                          <a
                            (click)="
                              $event.stopPropagation(); enterFolder(item)
                            "
                            (keydown.enter)="enterFolder(item)"
                            (keydown.space)="
                              $event.preventDefault(); enterFolder(item)
                            "
                            role="button"
                            class="madero-link tw-font-semibold u_ellipsis-lg"
                            tabindex="0"
                            [attr.aria-label]="'Open folder ' + item.name"
                          >
                            {{ item.name }}
                          </a>
                        </div>
                      </td>
                    </tr>
                  } @else {
                    <tr>
                      <td
                        class="item-name-cell tw-w-full tw-max-w-0 tw-overflow-hidden"
                      >
                        <div
                          class="tw-flex tw-min-w-0 tw-items-center tw-justify-between tw-gap-[5px]"
                        >
                          <div
                            class="tw-flex tw-items-center tw-gap-1 tw-min-w-0 tw-flex-1"
                          >
                            @if (data.multiple) {
                              <mat-checkbox
                                id="item-selector-cb-{{ itemId }}"
                                class="tw-shrink-0"
                                [checked]="
                                  _itemSelectorService.isSelected(item, false)
                                "
                                [ariaChecked]="
                                  _itemSelectorService.isSelected(item, false)
                                "
                                ariaCheckedElementId="item-selector-cb-{{
                                  itemId
                                }}-input"
                                aria-labelledby="item-label-{{ itemId }}"
                                (click)="
                                  _itemSelectorService.selectItem(item, false)
                                "
                              />
                            }
                            <span
                              class="tw-font-semibold tw-cursor-pointer tw-truncate tw-min-w-0"
                              [class.tw-ml-2]="!data.multiple"
                              id="item-label-{{ itemId }}"
                              (click)="selectItem(item)"
                            >
                              {{ item.name }}
                            </span>
                          </div>
                          <button
                            rv-button
                            variant="green-text"
                            class="tw-shrink-0"
                            [mat-dialog-close]="{ action: 'edit', item: item }"
                          >
                            Edit
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </ng-container>
                @if (
                  items.length === 0 &&
                  !selectFolderDialogService.loading() &&
                  !getScrollingList().loadingItems
                ) {
                  <tr>
                    <td class="tw-text-center tw-text-gray-500">
                      No {{ data.kind }}s found
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </cdk-virtual-scroll-viewport>
        }
      </mat-dialog-content>
      <rv-divider></rv-divider>
    </div>
  </mat-tab>
  @if (data.multiple) {
    <mat-tab
      label="Selected {{ data.kind }}s"
      [disabled]="selectedItems.length === 0"
    >
      <div class="tw-mt-6 tw-px-2.5 md:tw-px-6">
        <table class="tw-w-full">
          <thead>
            <tr class="list-header">
              <th>Name</th>
            </tr>
          </thead>
        </table>
      </div>
      <mat-dialog-content class="tw-h-[50vh] tw-overflow-y-auto">
        <table
          class="tw-table-fixed tw-w-full"
          rvSpinner="items-list-loader"
          [rvShowSpinner]="selectFolderDialogService.loading()"
        >
          <tbody>
            @for (item of selectedItems; track item.id) {
              <tr>
                <td
                  class="item-name-cell tw-w-full tw-max-w-0 tw-overflow-hidden"
                >
                  <div
                    class="tw-flex tw-min-w-0 tw-items-center tw-justify-between tw-gap-[5px]"
                  >
                    <div
                      class="tw-flex tw-items-center tw-gap-4 tw-min-w-0 tw-flex-1"
                    >
                      @if (data.multiple) {
                        <mat-checkbox
                          class="tw-shrink-0"
                          [checked]="
                            _itemSelectorService.isSelected(item, true)
                          "
                          (click)="_itemSelectorService.selectItem(item, true)"
                        />
                      }
                      <span
                        class="tw-font-semibold tw-cursor-pointer tw-truncate tw-min-w-0"
                        (click)="selectItem(item, true)"
                      >
                        {{ item.name }}
                      </span>
                    </div>
                    <button
                      rv-button
                      variant="green-text"
                      class="tw-shrink-0"
                      [mat-dialog-close]="{ action: 'edit', item: item }"
                    >
                      Edit
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </mat-dialog-content>
    </mat-tab>
  }
</mat-tab-group>
<mat-dialog-actions
  align="end"
  class="tw-p-2.5 md:tw-p-6 tw-gap-2 tw-flex-wrap"
>
  <button rv-button variant="secondary" (click)="dialogRef.close()">
    Cancel
  </button>
  @if (canAdd) {
    <button
      rv-button
      variant="secondary"
      [mat-dialog-close]="{ action: 'add' }"
    >
      Add {{ data.kind }}
    </button>
  }
  @if (data.multiple) {
    <button
      rv-button
      (click)="confirmSelection()"
      [disabled]="
        selectFolderDialogService.loading() ||
        (!someItemIsSelected && !someSelectedItemIsUnselected)
      "
    >
      Select
    </button>
  }
</mat-dialog-actions>
